import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Menu } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MoveToVehicleMini from './MoveToVehicleMini';
const MoveToVehicleMenu = ({ anchorEl, anchorPosition, open, onClose, options, selectedVehicleIds, onSelect, onSearchChange, onConfirm }) => {
    const { t } = useTranslation();
    const hasSelection = (selectedVehicleIds?.length ?? 0) > 0;
    return (_jsxs(Menu, { anchorEl: anchorEl, anchorReference: anchorPosition ? 'anchorPosition' : 'anchorEl', anchorPosition: anchorPosition ?? undefined, open: open, onClose: onClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, MenuListProps: { sx: { p: 0 } }, PaperProps: {
            sx: {
                mt: 1,
                borderRadius: 2,
                boxShadow: '0px 8px 24px rgba(145,158,171,0.24)'
            }
        }, children: [_jsx(MoveToVehicleMini, { options: options, selectedVehicleIds: selectedVehicleIds, onSelect: (vehicle) => {
                    onSelect(vehicle);
                }, onSearchChange: onSearchChange }), onConfirm && (_jsx(Box, { px: 1.5, pb: 1.5, children: _jsx(Button, { fullWidth: true, variant: 'contained', size: 'small', disabled: !hasSelection, onClick: onConfirm, children: t('actions.confirm') }) }))] }));
};
export default MoveToVehicleMenu;
